import React, {useEffect, useState} from "react";
import axiosInstance from "../../../api/api";
import {Col, Form, Row, Table} from "@themesberg/react-bootstrap";
import DetailCompetitor from "../Demand/DetailCompetitor";
import CardLayout from "../Layout/CardLayout";
import EmpleadoTable from "./EmpleadoTable";

const EmpleadoVenta = (ciemId) => {

    const contributionForm =
        <EmpleadoTable ciemId={ciemId}
                       tipoempleado={3}
                       nombreHeaderTabla={'empleadoDirectoTable'}
                       nombreHeaderTablatotales={'empleadoDirectoTotales'}
                       formEmpleado={'empleadoDirectoForm'} />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"empleadoDirectoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default EmpleadoVenta;